import {segment} from './helpers'

export const viewedPartnerForm = (origin) => segment('Viewed Partner Form', {origin})

export const savedPartnerInfo = (origin) => segment('Saved Partner Info', {origin})

export const updatedPartnerInfo = () => segment('Updated Partner Info')

/**
 * Fired when user attempts to submit partner information that contains invalid data.
 *
 * TODO: cleanup event post launch once product establishes baseline data
 *
 * @param {Object} payload
 * @param {String} payload.email Email submtitted to partner info form
 * @param {String} payload.firstName First name submitted to partner info form
 * @param {String} payload.lastName Last name submtitted to partner info form
 * @param {Boolean} payload.isEmailInvalid Determines if email provided is invalid
 * @param {Boolean} payload.isFirstNameInvalid Determines if first name provided is invalid
 * @param {Boolean} payload.isLastNameInvalid Determines if last name provided is invalid
 * @param {String} origin Source of error
 */
export const partnerInfoError = ({
  email,
  firstName,
  lastName,
  isEmailInvalid,
  isFirstNameInvalid,
  isLastNameInvalid,
  origin,
}) => {
  const segmentPayload = {
    isEmailInvalid,
    isFirstNameInvalid,
    isLastNameInvalid,
    origin,
  }

  if (isEmailInvalid) {
    segmentPayload.email = email
  }
  if (isFirstNameInvalid) {
    segmentPayload.firstName = firstName
  }
  if (isLastNameInvalid) {
    segmentPayload.lastName = lastName
  }

  segment('Partner Info Error', segmentPayload)
}

// TODO: cleanup event post launch once product establishes baseline data
export const clickedSkipForNow = () => segment('Clicked Partner Info Modal Skip Button')
